export default __webpack_public_path__ + "static/media/contactHero.398787f6.jpg";